import React from 'react'
import { ModalProps } from '../../interfaces/modal'
import { useLoaderStore } from '../../stores/components/loader';
import { useInvoiceStore } from '../../stores/invoice';
import { showToastError, showToastSuccess } from '../../services/toast';
import { validateProforma } from '../../api/invoices';
import { validateCreditNote } from '../../api/creditNotes';
import { ModalButton, ModalConfirmText, ModalShell } from '../ui/modals/ModalShell';

const InvoiceGenerated: React.FC<ModalProps> = ({ closeModal }) => {
    const { setIsLoadingDocuments } = useLoaderStore();
      // Store
  const {
    tabInvoice,
    setProformas,
    idsProformasSelected,
    setIdsProformasSelected,
    updateProforma,
    setUpdateProforma,
    setDataFilterProformas,
  } = useInvoiceStore();

    const handleValidateProforma = () => {
      setIsLoadingDocuments(true);
        closeModal();
        const validateAndUpdate = (validationFunction: (ids: number[]) => Promise<any>) => {
          validationFunction(idsProformasSelected)
            .then(() => {
              setIsLoadingDocuments(false);
              showToastSuccess("Proforma validée avec succès");
              setIdsProformasSelected([]);
           
              setUpdateProforma(!updateProforma);
              setProformas([]);
              setDataFilterProformas([]);
            })
            .catch(() => {
              showToastError("Erreur lors de la validation des proforma");
              setIsLoadingDocuments(false);
            });
        };
        if (tabInvoice === "Proformas" && idsProformasSelected.length > 0) {
          validateAndUpdate(validateProforma);
        } else if (tabInvoice === "Avoirs" && idsProformasSelected.length > 0) {
          validateAndUpdate(validateCreditNote);
        } else if (idsProformasSelected.length === 0) {
          showToastError("Veuillez sélectionner une proforma");
          setIsLoadingDocuments(false);
        }
      };
      
    return (
        <ModalShell
          title="Génération de factures"
          size="sm"
          onClose={() => closeModal()}
          footer={
            <>
              <ModalButton variant="secondary" onClick={() => closeModal()}>
                Annuler
              </ModalButton>
              <ModalButton
                variant="success"
                type="submit"
                onClick={handleValidateProforma}
              >
                Générer
              </ModalButton>
            </>
          }
        >
          <ModalConfirmText>
            Etes-vous sûr de bien vouloir générer toutes ses proformas en factures ?
          </ModalConfirmText>
          <p className="mt-3 rounded-xl bg-amber-50 px-3 py-2 text-center font-Nunito text-xs font-semibold text-amber-800 ring-1 ring-amber-100 ring-inset">
            Cette action est irréversible
          </p>
        </ModalShell>
      );
    };
    
    export default InvoiceGenerated;